import React from 'react';

const IconBountyHunter = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className='w-8  h-8'>
      <path
        opacity='.6'
        d='M64 16C64 7.2 71.2 0 80 0H96c8.8 0 16 7.2 16 16s-7.2 16-16 16V70c-13.5 21-22 45.6-23.7 72.2L65 256.5c-.2 3.5 0 6.9 .6 10.2c-1-3.4-1.6-7-1.6-10.7V16zm49.3 236.6l5.3-82.4c29 16.3 64.2 48.1 71.9 97.8l-77.2-15.4zM257.5 268c7.6-49.7 42.9-81.5 71.9-97.8l5.3 82.4L257.5 268zM166.4 459.2l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8v40H160V472c0-5 2.4-9.8 6.4-12.8z'
        fill='currentColor'
      />
      <path
        d='M224 48c46 0 85.4 30 99 72H125c13.6-42 52.9-72 99-72zm24 123.5l80.5-15.1 6.2 96.2L248 269.9V171.5zm-48 0v98.4l-86.7-17.3 6.2-96.2L200 171.5zM224 0C143.9 0 77.5 62.2 72.3 142.2L65 256.5c-1.3 20 12.4 37.9 32.1 41.8l100.8 20.2c5.2 1 10.4 1.6 15.7 1.6h20.9c5.3 0 10.5-.5 15.7-1.6L351 298.3c19.7-3.9 33.4-21.8 32.1-41.8l-7.4-114.3C370.5 62.2 304.1 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512H160V472c0-5 2.4-9.8 6.4-12.8l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8v40H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4C60.2 352 0 412.2 0 486.4z'
        fill='currentColor'
      />
    </svg>
  );
};

export default IconBountyHunter;
